import React, { useEffect, useState } from 'react';

import { get } from '../Services/http';
import { translate } from '../Services/translation';
import constants from '../constants';
import Button from './Button';

export default function LanguageAndCountrySelector() {
    const [data, setData] = useState({
        languageCode: constants.languages[0].value,
        countryCode: constants.countries[0].value,
    });

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        let languageCode = data.languageCode;
        let countryCode = data.countryCode;
        for (let i = 0; i < constants.languages.length; i++) {
            if (constants.languages[i].selected) {
                languageCode = constants.languages[i].value;
                break;
            }
        }
        for (let i = 0; i < constants.countries.length; i++) {
            if (constants.countries[i].selected) {
                countryCode = constants.countries[i].value;
                break;
            }
        }

        setData({
            languageCode: languageCode,
            countryCode: countryCode,
        });
    }, []);

    const onChange = (key, value) => {
        setData({ ...data, [key]: value });
    };

    const submit = async () => {
        setLoading(true);
        const requestContext = window.__litium.requestContext;
        const params = new URLSearchParams(data);
        for (const key in requestContext) {
            if (Object.hasOwnProperty.call(requestContext, key)) {
                const element = requestContext[key];
                params.append(key, element);
            }
        }

        return get('/api/navigation/setcountry/?' + params.toString())
            .then((response) => response.text())
            .then((result) => {
                console.log(result);
                if (result.length) {
                    window.location.href = result;
                }
            })
            .catch((ex) => console.log(ex))
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <form>
            <div className="row">
                <div className="small-12">
                    <label className="form__label" htmlFor="language">
                        {translate('header.language.language')}
                    </label>
                    <select
                        id="language"
                        className="form__input"
                        autoComplete="language-name"
                        name="languageCode"
                        value={data.languageCode}
                        onChange={(event) => onChange('languageCode', event.target.value)}
                    >
                        {constants.languages.map((language, index) => (
                            <option key={index} value={language.value}>
                                {language.text}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="small-12">
                    <label className="form__label" htmlFor="country">
                        {translate('header.language.deliverycountry')}
                    </label>
                    <select
                        id="country"
                        className="form__input"
                        autoComplete="country-name"
                        name="countryCode"
                        value={data.countryCode}
                        onChange={(event) => onChange('countryCode', event.target.value)}
                    >
                        {constants.countries.map((country, index) => (
                            <option key={index} value={country.value}>
                                {country.text}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="small-12">
                    <Button title={translate('general.save')} disabled={loading} onClick={submit} />
                </div>
            </div>
        </form>
    );
}
